import { render, staticRenderFns } from "./KeywordFilterIcon.vue?vue&type=template&id=52c44315&scoped=true&"
import script from "./KeywordFilterIcon.vue?vue&type=script&lang=js&"
export * from "./KeywordFilterIcon.vue?vue&type=script&lang=js&"
import style0 from "./KeywordFilterIcon.vue?vue&type=style&index=0&id=52c44315&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c44315",
  null
  
)

export default component.exports